import type { TFunction } from "react-i18next"
import * as Yup from "yup"
import { PaymentSchedule } from "./constants"

export const getPayrollChangeValidationSchema = (t: TFunction) =>
  Yup.object().shape({
    selectedEngagementId: Yup.string().trim().required(t("form.required.engagementId")),
    paymentType: Yup.string().trim().required(t("form.required.paymentType")),
    amount: Yup.number()
      .typeError(t("form.required.amountNumber"))
      .moreThan(0, t("form.required.moreThanZero"))
      .required(t("form.required.amount")),
    paymentSchedule: Yup.string().trim().required(t("form.required.paymentSchedule")),
    month: Yup.string()
      .trim()
      .when("paymentSchedule", {
        is: value => value === PaymentSchedule.OneTime,
        then: Yup.string().required(t("form.required.month")),
      }),
    startingMonth: Yup.string()
      .trim()
      .when("paymentSchedule", {
        is: value => value === PaymentSchedule.Recurring,
        then: Yup.string().required(t("form.required.month")),
      }),
    endingMonth: Yup.string()
      .trim()
      .when("paymentSchedule", {
        is: value => value === PaymentSchedule.Recurring,
        then: Yup.string().required(t("form.required.month")),
      }),
    notes: Yup.string().trim().max(2000, t("form.notes.maxLength")),
  })
